import { DrawerObject } from '@/components/drawer/drawer.types';
import { FormBuilderComponent } from '@/components/form-builder/form-builder.component';
import { DynamicForm } from '@/components/form-builder/form-builder.types';

interface ICompanySubmissionsBlackListAddDrawerObject {
  formObject: DynamicForm;
  toggleVisibility: () => void;
  action: () => void;
}

export const companySubmissionsBlackListAddDrawerObject = ({
  formObject,
  toggleVisibility,
  action,
}: ICompanySubmissionsBlackListAddDrawerObject): DrawerObject => {
  return {
    title: 'settings.blackList.add.title',
    width: '30vw',
    description: '',
    component: {
      outlet: FormBuilderComponent,
      props: {
        formObject,
      },
    },
    actions: [
      {
        label: 'settings.blackList.add.cancel',
        onClick: () => toggleVisibility(),
      },
      {
        label: 'settings.blackList.add.add',
        onClick: () => action(),
      },
    ],
  };
};
